import Navbar from '@/components/Landing/Nav/Nav.vue'
import SideMenu from "@/components/Main/SideMenu/SideMenu.vue";
import Map from '@/components/Map/Map.vue'
import AdMenu from '@/components/Main/AdMenu/AdMenu.vue'
import HowFarGraph from '@/components/Main/HowFarGraph/HowFarGraph.vue'
import Feed from '@/components/Main/Feed/Feed.vue'
import ExpandableMenuList from '@/components/Main/ExpandableMenuList/ExpandableMenuList.vue'

import LoginModal from "@/components/Auth/LoginModal/LoginModal.vue";
import InviteModal from "@/components/Auth/InviteModal/InviteModal.vue";
import ResetModal from "@/components/Auth/ResetModal/ResetModal.vue";
import SignupModal from "@/components/Auth/SignupModal/SignupModal.vue";
import Hamburger from "@/components/Main/Hamburger/Hamburger.vue";
import Intersect from "vue-intersect";

import CircleService from '@/services/circle'
import ProfileService from '@/services/profile'

import DataHandlerService from "@/services/data";
import ContentService from "@/services/content";
import InMemoryDb from "@/services/inmemorydb";
import * as constants from "@/constants/index";
import { mapState, mapActions } from "vuex";
import GeometryUtils from "@/utils/geometry";
import router from '../../router';
import AuthService from '../../services/auth';


const data = new DataHandlerService();
const content = new ContentService();
const InMemoryDatabase = new InMemoryDb();
const geometryUtils = new GeometryUtils();

const circleService = new CircleService();
const profileService = new ProfileService();
const LIMIT = 4;

export default {
  name: 'Blog',
  props: ['auth', 'authenticated'],
  components: {
    Navbar,
    SideMenu,
    Map,
    AdMenu,
    HowFarGraph,
    LoginModal,
    InviteModal,
    ResetModal,
    SignupModal,
    Feed,
    Hamburger,
    ExpandableMenuList,
    Intersect,
  },
  data() {
    return {
      STATES: ["FEED", "NEW_POST", "TOPICS", "SETTINGS", "CAMPAIGNS"],
      VIEWS: ["INDEX", "CIRCLE", "TOPICS"],
      currentView: '',
      user: null,
      authFlag: null,
      tracker: null,
      trackers: null,
      altHeaderText: null,
      page: 1,
      coordinates: { lat: 9.0748812, lng: 7.465183 },
      markers: null,
      infoWindows: null,
      suggestedProfile: { phone: '' },
      selectedTracker: null,
      loadingTopics: false,
      circleTopics: null,
      selectedCircle: null,
      selectedTopic: null,
      statBars: [],
      statBars6Hrs: [],
      feed: null,
      tempFeed: null,
      topicFeed: null,
      contentLoading: true,
      menuState: false,
      circles: [],
      sections: {},
      publicCircles: null,
    }
  },
  computed: {
    // ...mapState(['circles']),
    toggleMenuState: function () {
      return this.toggler
    }
  },
  watch: {
    'circles': {
      handler: function (circles) {
        let markers = [];
        circles.map(val => {
          if (val.locations && val.locations.length) {
            val.locations.map(location => {
              markers.push({
                position: { lat: location.latitude, lng: location.longitude },
                info: {
                  content: `<div>
                      <h6 style='margin: 7px auto 3px auto;font-size: 14px;'> ${location.title}</h6>
                    </div>`,
                  open: false,
                  canClose: true
                },
                shape: { path: 'ellipse', fillColor: 'yellow', fillOpacity: 0.4 }
              })
            });
          }
        })
        this.markers = markers;
      },
      immediate: true,
      deep: true
    },
    "$route.params": {
      handler: async function (val) {
        this.loadRouteContent(val)
      },
      immediate: true,
      deep: true
    },
  },
  created() {
    const auth = new AuthService()
    this.authFlag = auth.authenticated
    
    this.currentView = this.VIEWS[0]
    this.user = data.getUserData();
    this.fetchCircles(this.user._id);
    this.loadFeed();
    this.loadMenuCircles();
    this.loadRouteContent(this.$route.params);

    if (this.user._id) {
      const from = Math.round(new Date().getTime() / 1000) - (30 * 24 * 60 * 60)
      const from6hrs = Math.round(new Date().getTime() / 1000) - (6 * 60 * 60)
      const to = Math.round(new Date().getTime() / 1000)

      content.readProfileTimestream(this.user._id, from6hrs, to)
        .then(res => {
          const average = res.data.average
          const timeline = res.data.timeline.slice(0, 54).reverse()
          timeline.map(item => {
            let bar = {}
            if (item >= average) {
              bar['value'] = item
              bar['evaluation'] = 1
              bar['average'] = average
            }
            if (item < average) {
              if (item > 0) {
                bar['value'] = item
                bar['evaluation'] = 0
                bar['average'] = average
              } else {
                bar['value'] = item
                bar['evaluation'] = -1
                bar['average'] = average
              }
            }
            // return bar;
            this.statBars6Hrs.push(bar)
          })

        })
      content.readProfileTimestream(this.user._id, from, to)
        .then(res => {
          // const average = res.data.average
          const nonZero = res.data.timeline.filter(item => item > 0)
          let nonZeroSum = 0
          for (var i in nonZero) {
            nonZeroSum += nonZero[i]
          }
          const average = nonZeroSum / nonZero.length
          const timeline = res.data.timeline.reverse()
          timeline.map(item => {
            let bar = {}
            if (item >= average) {
              bar['value'] = item
              bar['evaluation'] = 1
              bar['average'] = average
            }
            if (item < average) {
              if (item > 0) {
                bar['value'] = item
                bar['evaluation'] = 0
                bar['average'] = average
              } else {
                bar['value'] = item
                bar['evaluation'] = -1
                bar['average'] = average
              }
            }
            // return bar;
            this.statBars.push(bar)
          })

        })
    }

    this.$root.$on('fetchMoreContent_Feed', async () => {
      this.contentLoading = true
      this.fetchContentFromAPISinglePage(++this.page)
    })

  },
  mounted() {
    this.geolocate()
    if (!this.authFlag) {
      $('#loginModal').modal('show')
    }
  },
  methods: {
    ...mapActions(["fetchCircles"]),
    toggler: function () {
      this.menuState = !this.menuState
    },
    loadMore(e) {
      const btn = e.srcElement;

      btn.disabled = true;
      btn.innerText = 'Loading'
      btn.classList.add('btn--loading');

    },
    has(obj, path) {
      if (typeof path !== "string") {
        return false;
      }
      var path_array = path.split(".");
      if (obj.hasOwnProperty(path_array[0])) {
        if (path_array.length > 1) {
          var newPath = path_array
            .slice(1)
            .join(".")
            .toString();
          return has(obj[path_array[0]], newPath);
        }
        return obj.hasOwnProperty(path_array[0]);
      }
      return false;
    },
    truncate_media (topic) {
      let all = topic.first_media.body.replace(/\n\r\t/g, "").split(' ').filter(item => item.match(/\w/))
      if (all.length > 26) {
        return all.splice(0, 25).join(' ') + ' ...'
      } else {
        return all.join(' ')
      }
    },
    setSelectedTracker(tracker) {
      this.selectedTracker = tracker
    },
    geolocate: function () {
      navigator.geolocation.getCurrentPosition(position => {
        this.coordinates = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },
    setCircleTopics(circle) {
      let el = this.$refs.sideMenuArea
      this.$nextTick(() => {
        if(el) { document.documentElement.scrollTop = el.scrollTop }
      })
      const circle_id = circle._id;
      this.loadingTopics = true;
      this.circleTopics = null;
      if (circle.locations && circle.locations.length) {
        const allPoints = circle.locations.map(location => [location.latitude, location.longitude]);
        const centerOfPoints = geometryUtils.getCenterOfPoints(allPoints) || this.coordinates;
        this.coordinates = centerOfPoints;
      }
      circleService.getCircleTopics(circle_id, 10, 1)
        .then(res => {
          this.selectedCircle = circle;
          this.loadingTopics = false;
          this.circleTopics = res.data;
        }).catch(err => {
          this.loadingTopics = false;
          this.selectedCircle = null;
          //(err && err.message) ? (this.$root.$emit("ShowErrorNotification", err.message)) :
          //(this.$root.$emit("ShowErrorNotification", "An error occurred. Please try again."));
        })
    },
    getCircleTopics(circle) {
      let el = this.$refs.sideMenuArea
      this.$nextTick(() => {
        if(el) { document.documentElement.scrollTop = el.scrollTop }
      })
      const circle_id = circle._id;
      this.loadingTopics = true;
      this.circleTopics = null;
      if (circle.locations && circle.locations.length) {
        const allPoints = circle.locations.map(location => [location.latitude, location.longitude]);
        const centerOfPoints = geometryUtils.getCenterOfPoints(allPoints) || this.coordinates;
        this.coordinates = centerOfPoints;
      }
      circleService.getCircleTopics(circle_id, 10, 1)
        .then(res => {
          this.selectedCircle = circle;
          this.loadingTopics = false;
          this.circleTopics = res.data;
        }).catch(err => {
          this.loadingTopics = false;
          this.selectedCircle = null;
          //(err && err.message) ? (this.$root.$emit("ShowErrorNotification", err.message)) :
          //(this.$root.$emit("ShowErrorNotification", "An error occurred. Please try again."));
        })
    },
    async fetchContentFromAPISinglePage(page) {
      try {
        const contentFromAPI = await content.readProfileFeed(
          this.user._id,
          page,
          LIMIT
        )
        const allFeed = [...contentFromAPI.content, ...(this.tempFeed || [])]

        this.tempFeed = Array.from(new Set(allFeed.map(s => s._id))).map(_id =>
          allFeed.find(s => s._id === _id)
        )
        this.contentLoading = false
        this.feed = [...this.tempFeed]

        InMemoryDatabase.saveFeed(this.tempFeed)

        if (this.page > contentFromAPI.max) {
          this.page =
            contentFromAPI.content.length < LIMIT
              ? contentFromAPI.max - 1
              : contentFromAPI.max
        }
      } catch (e) {
        /*this.$root.$emit(
          'ShowErrorNotification',
          'An error occurred. Please try again.'
        )*/
      }
    },
    async fetchContentFromAPIMultiPage(max_page) {
      for (let i = 1; i <= max_page; i++) {
        try {
          const temp = [
            ...(await content.readProfileFeed(this.user._id, page, LIMIT)
              .content),
            ...(this.tempFeed || [])
          ]

          if (i === max_page) {
            this.tempFeed = Array.from(new Set(temp.map(s => s._id))).map(_id =>
              temp.find(s => s._id === _id)
            )
            this.contentLoading = false
            this.feed = [...this.tempFeed]
            InMemoryDatabase.saveFeed(this.tempFeed)
          }
        } catch (e) {
          /*this.$root.$emit(
            'ShowErrorNotification',
            'An error occurred. Please try again.'
          )*/
          break
        }
      }
    },
    async loadFeed() {
      try {
        const temp = await InMemoryDatabase.retrieveFeed()
        if (temp.length) {
          this.tempFeed = temp
          this.feed = [...this.tempFeed]
          this.page = Math.round(temp.length / LIMIT)

          if (this.page > 1) {
            this.fetchContentFromAPIMultiPage(this.page)
          } else {
            this.page = 1
            this.fetchContentFromAPISinglePage(this.page)
          }
        } else {
          this.fetchContentFromAPISinglePage(++this.page)
        }
      } catch (e) {
        this.page = 1
        this.fetchContentFromAPISinglePage(this.page)
      }
    },
    async getTopicPosts(topic) {
      let el = this.$refs.contentArea
      this.$nextTick(() => {
        if(el) {
          el.scrollTop = 0
          document.documentElement.scrollTop = el.scrollHeight
        }
      });
      this.selectedTopic = topic;
      this.contentLoading = true;
      this.topicFeed = []
      content.readTopicFeed(topic._id, 1, LIMIT)
        .then(res => {
          this.topicFeed = res.content;
          this.contentLoading = false;
          
          let q = this.$route.query
          if(q && q.open && q.open === "topic") {
            this.$root.$emit('ShowThread', this.$route.params.topic_id)
          }
        })
        .catch(err => {
          this.contentLoading = false;
          (err && err.message) ? (this.$root.$emit("ShowErrorNotification", err.message)) :
            (this.$root.$emit("ShowErrorNotification", "An error occurred. Please try again."));
        })
    },
    loadMenuCircles() {
      const user = data.getUserData();
      const profileId = user._id;
      const sects = ['recommended', 'created', 'administrator', 'member']

      circleService.getProfileCircleSections(profileId).then(sections => {
        let sorted = {}
        for (var i in sections) {
          if (sects.includes(i)) {
            sorted[i] = sections[i]
          }
        }
        this.sections = sorted
        try {
          this.publicCircles = sections['public']
        } catch (e) {
          console.log(e)
        }
      })
    },
    loadPublicCircles() {
      let el = this.$refs.contentArea
      this.circles = this.publicCircles.data
      this.$nextTick(() => {
        if(el) {
          el.scrollTop = 0
          document.documentElement.scrollTop = el.scrollHeight
        }
      });
    },
    reachedEndOfCircles() {
      circleService.getPublicCircles(this.publicCircles.limit, this.publicCircles.page + 1)
        .then(res => {
          this.publicCircles.page += 1
          res.map(item => {
            if (!this.publicCircles.data.find(f => f._id === item._id)) {
              this.publicCircles.data.push(item)
            }
          })
        })
        .catch(err => {
          console.log(err)
        })
    },


    readTopicPage() {
      const { circle_id, topic_id } = this.$route.params
      this.currentView = this.VIEWS[2]
      this.topicFeed = null
      Promise.all([circleService.readCircle(circle_id), content.readSingleTopic(topic_id)]).then(([circle, topic]) => {
        this.getTopicPosts(topic)
      }).catch(err => {
        // console.log(err)
        router.replace('/status')
          (err && err.message) ? (this.$root.$emit("ShowErrorNotification", err.message)) :
          (this.$root.$emit("ShowErrorNotification", "An error occurred. Please try again."));
      })
    },
    gotoTopic(topic) {
      this.$route.path !== `/status/${this.$route.params.circle_id}/${topic._id}` && router.replace(`/status/${this.$route.params.circle_id}/${topic._id}`);
    },

    readCirclePage() {
      const { circle_id } = this.$route.params
      this.currentView = this.VIEWS[1]
      this.topicFeed = null
      circleService.readCircle(circle_id).then(circle => {
        this.getCircleTopics(circle)
      }).catch(err => {
        console.log(err);
        this.$route.path !== '/status' && router.replace('/status');
          (err && err.message) ? (this.$root.$emit("ShowErrorNotification", err.message)) :
          (this.$root.$emit("ShowErrorNotification", "An error occurred. Please try again."));
      })
    },
    gotoCircle(circle) {
      this.$route.path !== `/status/${circle._id}` && router.replace(`/status/${circle._id}`)
    },

    loadRouteContent(val) {
      if (val) {
        if (val.topic_id) {
          this.readTopicPage()
        } else {
          if (val.circle_id) {
            this.readCirclePage()
          } else {
            this.$route.path !== '/status' && router.replace('/status')
          }
        }

      } else {
        this.$route.path !== '/status' && router.replace('/status')
      }
    }
  }
}
